nav-icon
<template>
	<div class="nadlan-menu sticky-menu sticky-div" id="sticky-div">
		<div class="desktop-content">
			<div class="container">
				<div class="title-container">
					<div
						v-for="(niceToMeet, index) in niceToMeets"
						:key="index"
						class="nav-item"
					>
						<div
							class="nav-item clickable-text"
							:class="{ active1: activeIndex === index }"
							@click="setActive(index)"
						>
							<img
								class="img-cont"
								height="25px"
								style="margin-left: 8px"
								:src="niceToMeet.icon"
								alt="חינוך בשכונה"
							/>
							<!-- <div class="clickable-text"> -->
							<span>{{ niceToMeet.title }}</span>
							<!-- </div> -->
						</div>
						<div class="nav-divider">
							<svg
								v-if="index < niceToMeets.length - 1"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 2 30"
								class="nav-icon"
							>
								<line
									x1="1"
									y1="0"
									x2="1"
									y2="30"
									stroke="#05446C"
									stroke-width="2"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "NearByToolbar",
		props: {
			msg: String,
		},
		data() {
			return {
				activeIndex: null,
				niceToMeets: [],
				centerIndex: -1,
				scrollPosition: 0,
				contentWidth: 0,
				additional_total: 0,
				buttonClicked: false,
			};
		},
		computed: {
			routeName() {
				return this.$route.name;
			},
			nearByObjects() {
				var objects = this.$store.state.nearByMenu;

				return objects;
			},
		},
		methods: {
			setActive(index) {
				this.activeIndex = index;

				//scroll to the selected item
				var element = document.getElementById(this.niceToMeets[index].name);
				if (!element) {
					return;
				}
				// get elements child div - 'titleContainer':
				var titleContainer = element.querySelector(".titleContainer");
				if (titleContainer) {
					titleContainer.scrollIntoView({
						behavior: "smooth",
						block: "center",
					});
				}

				var layer_name = this.niceToMeets[index].mapLayerName;
				// filter nearByObjects by layer_name
				if (layer_name == null || layer_name == undefined || layer_name == "") {
					return;
				}
				var li = this.nearByObjects.filter(function (obj) {
					return obj.mapLayerName === layer_name;
				});
				if (li.length == 0) {
					return;
				} else {
					this.$store.state.selectedNearByObject = li[0];
				}
				// this.$store.state.selectedNearByObject = this.nearByObjects.filter(function (obj) {
				//     return obj.mapLayerName === layer_name;
				// })[0];
				this.$store.state.nearByMenu.forEach(function (obj) {
					obj.buttonClicked = false;
				});
				//set buttonClicked new property (if not exist)

				if (
					!Object.prototype.hasOwnProperty.call(
						this.nearByObjects[index - 1],
						"buttonClicked",
					)
				) {
					//set buttonClicked new property
					this.$set(this.nearByObjects[index - 1], "buttonClicked", true);
				}
				this.nearByObjects[index - 1].buttonClicked = true;
			},
			filterObj(obj) {
				this.$store.state.selectedNearByObject = obj;
				this.$store.state.nearByMenu.forEach(function (obj) {
					obj.buttonClicked = false;
				});
				obj.buttonClicked = true;
			},
		},
	};
</script>

<style scoped>
	.scroll-container {
		margin-bottom: 20px;
		position: relative;
		max-width: 900px;
		width: 100%;
		overflow: hidden;
		background-color: white;
		border-radius: 20px;
		padding: 5px 40px;
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
		z-index: 1;
	}

	.active1 {
		border-bottom: 2px solid #0d3efb;
		color: #0d3efb;
	}

	.nav-item {
		cursor: pointer;
		display: flex;
		align-items: center;
		color: #05446c;
		text-decoration: none;
		padding-top: 5px;
		height: 40px;
		z-index: 26;
	}
	.nav-icon {
		width: 24px;
		height: 35px;
		margin-left: 5px;
		padding-top: 5px;
		margin-bottom: 10px;
	}
	.content-section {
		margin-top: 20px;
		padding: 20px;
	}

	.title-container {
		padding-left: 32px;
		padding-right: 32px;
		align-items: center;
		font-weight: bold;
		align-items: center;
		height: 50px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: stretch;
		-ms-flex-align: stretch;
		align-items: stretch;
		text-align: center;
	}
	.nav-divider {
		color: #05446c;
		margin-bottom: -15px;
	}
	@media (max-width: 768px) {
		.desktop-content {
			display: none;
		}
		.mobile-content .nav-item {
			border-bottom: 1px solid #ccc;
		}
		.mobile-content .content-section {
			display: none;
		}
		.mobile-content .content-section.active {
			display: block;
		}
	}
	@media (min-width: 769px) {
		.mobile-content {
			display: none;
		}
	}

	.clickable-text {
		cursor: pointer;
		color: inherit;
		text-decoration: none;
		font-size: 1.3em; /* Adjust as needed */
	}

	.clickable-text:hover {
		color: #0d3efb;
	}

	.sticky-menu nav > div.active {
		border-bottom: 2px solid #0d3efb;
	}

	.sticky-menu nav > div.active a {
		color: #0d3efb;
	}

	.sticky-div {
		position: -webkit-sticky; /* For Safari */
		position: fixed;
		/*z-index: 1000; */
	}
</style>
